module.exports = __webpack_public_path__ + "static/img/demo.f4b3b6fb.svg";